<template>
	<div class="img">
		<ik-image :width="width" :path="path" :transformation="transformation" />
	</div>
</template>

<script>
export default {
	name: 'Imgx',
	data() {
		return {
			breakpoints: [480, 1024, 1800],
		};
	},
	props: {
		src: String,
	},
	computed: {
		path() {
			const url = this.src.split('/');
			return url[7];
		},
		width() {
			const width = window.innerWidth;
			let t;
			if (width < 480) {
				t = 480;
			} else if (width < 1024) {
				t = 400;
			} else {
				t = 600;
			}
			return t;
		},
		transformation() {
			const width = window.innerWidth;
			let t = [];
			if (width < 480) {
				t = [{ width: 480, height: 480 }];
			} else if (width < 1024) {
				t = [{ width: 250, height: 250 }];
			} else {
				t = [{ width: 600, height: 600 }];
			}
			return t;
		},
	},
};
</script>
